export enum PlanFieldNames {
	autoEnroll = 'autoEnroll',
	planDependency = 'medicalPlanDependency',
	planDependencyOptions = 'planDependencyOptions',
	planEnds = 'planEnds',
	planStarts = 'planStarts',
	legalText = 'legalText',
}
